import { VendorBlockData } from "../../reducers/vendor/VendorBlockDataReducer";

export type VendorBlockDataAction =
  | {
      type: "ON_CHANGE_VENDOR_BLOCK_DATA";
      payload: [input: string, value: any];
    };
  

function selectVendorBlock(input: string, value: any): VendorBlockDataAction {
  return {
    type: "ON_CHANGE_VENDOR_BLOCK_DATA",
    payload: [input, value],
  };
}


export const VendorBlockDataAction = {
selectVendorBlock  
};

